import React, { useState, useEffect } from "react";
import "./itemTable.css";
import { Tooltip } from "@material-ui/core";

const ConfigEditor = ({
  data,
  modelId,
  newConfigGroup,
  handleDelete,
  setData,
  createValue,
}) => {
  const [configGroups, setConfigGroups] = useState([]);
  const [openValueDialog, setOpenValueDialog] = useState(false);
  const [currentEditIndex, setCurrentEditIndex] = useState(null);
  const [valueDialogData, setValueDialogData] = useState([]);
  const [newValue, setNewValue] = useState({ value: "", description: "" });
  const [configSearchText, setConfigSearchText] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(null);

  useEffect(() => {
    setConfigGroups(newConfigGroup.map((x) => x.label));
    console.log("#####: ", newConfigGroup);
  }, [newConfigGroup]);

  useEffect(() => {
    console.log(data);
    // setData(formatInitialData());
  }, [data]);

  const transformAccessoryToDropdown = (input, i) => {
    const { Name = "", Values = [] } = input?.obj || {};
    const [item = null] = newConfigGroup;
    const output = {
      modelId: modelId || "", // e.g. "522d0ea7-af85-42b5-8130-d48ccb710dbd"
      ddName: Name, // e.g. "sUnit"
      description: "", // e.g. "Unit Size"
      sort: i + 1,
      configGroupId: item?.configGroupId || "", // e.g. "c8638a8f-b368-42b1-b310-c3b6701cc2db"
      columnType: "Dropdown",
      values: [],
    };

    let sortCounter = 1;

    Values.forEach((item) => {
      output.values.push({
        value: item.Value,
        description: item.Attributes.Description || item.Value,
        isActive: item.State === 1,
        sort: sortCounter++,
      });
    });

    return output;
  };

  // Handler for updating any field in formattedData
  const updateFormattedData = (index, field, value) => {
    const updated = [...data];
    updated[index][field] = value;
    setData(updated);
  };

  const handleNameChange = (index, value) => {
    updateFormattedData(index, "name", value);
  };

  const handleDescriptionChange = (index, value) => {
    updateFormattedData(index, "description", value);
  };

  const handleConfigGroupChange = (index, value) => {
    updateFormattedData(index, "configGroup", value);
    setConfigSearchText(value);
  };

  const handleTypeChange = (index, value) => {
    updateFormattedData(index, "type", value);
  };

  const handleValueDialogOpen = (index) => {
    setCurrentEditIndex(index);
    // Create a deep copy of the values to ensure changes in the dialog
    // don't affect the original data until saved
    setValueDialogData(JSON.parse(JSON.stringify(data[index].values)));
    setOpenValueDialog(true);
  };

  const handleValueDialogClose = () => {
    setOpenValueDialog(false);
    setCurrentEditIndex(null);
    setValueDialogData([]);
    setNewValue({ value: "", description: "" });
  };

  const handleValueChange = (index, field, value) => {
    const updated = [...valueDialogData];
    updated[index][field] = value;
    setValueDialogData(updated);
  };

  const handleAddValue = () => {
    if (newValue.value.trim() !== "") {
      setValueDialogData([...valueDialogData, { ...newValue }]);
      setNewValue({ value: "", description: "" });
    }
  };

  const handleRemoveValue = (index) => {
    const updated = [...valueDialogData];
    updated.splice(index, 1);
    setValueDialogData(updated);
  };

  const handleSaveValues = () => {
    if (currentEditIndex !== null) {
      const updated = [...data];
      updated[currentEditIndex].values = [...valueDialogData];
      setData(updated);
    }
    handleValueDialogClose();
  };

  const handleDeleteChip = (itemIndex, valueIndex, e) => {
    e.stopPropagation();
    const updated = [...data];
    updated[itemIndex].values.splice(valueIndex, 1);
    setData(updated);
  };

  const handleAddConfigGroup = (newGroup) => {
    if (newGroup && !configGroups.includes(newGroup)) {
      setConfigGroups([...configGroups, newGroup]);
    }
  };

  const handleConfigSearchChange = (index, value) => {
    handleConfigGroupChange(index, value);
    setConfigSearchText(value);
  };

  const handleConfigSelect = (index, value) => {
    handleConfigGroupChange(index, value);
    if (value && !configGroups.includes(value)) {
      createValue(value);
    }
    setDropdownOpen(null);
  };

  const toggleDropdown = (index, e) => {
    e.stopPropagation();
    setDropdownOpen(dropdownOpen === index ? null : index);
    setConfigSearchText(data[index].configGroup);
  };

  const closeDropdown = () => {
    setTimeout(() => {
      setDropdownOpen(null);
    }, 200);
  };

  const filteredConfigGroups = configGroups.filter((group) =>
    group?.toLowerCase().includes((configSearchText || "")?.toLowerCase())
  );

  const displayConsoleData = () => {
    console.log(
      data.map((e, i) => {
        return transformAccessoryToDropdown(e, i);
      })
    );
  };

  return (
    <div className="config-editor">
      <div className="table-container">
        <table className="config-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Config Group</th>
              <th>Type</th>
              <th>Values</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>
                  <Tooltip title={item.name}>
                    <input
                      type="text"
                      value={item.name}
                      onChange={(e) => handleNameChange(index, e.target.value)}
                      className="table-input"
                    />
                  </Tooltip>
                </td>
                <td>
                  <Tooltip title={item.description}>
                    <input
                      type="text"
                      value={item.description}
                      onChange={(e) =>
                        handleDescriptionChange(index, e.target.value)
                      }
                      className="table-input"
                    />
                  </Tooltip>
                </td>
                <td className="dropdown-cell">
                  <div className="custom-dropdown">
                    <Tooltip title={item.configGroup}>
                      <input
                        type="text"
                        value={item.configGroup}
                        onChange={(e) =>
                          handleConfigSearchChange(index, e.target.value)
                        }
                        className="table-input"
                        placeholder="Search config group"
                        onClick={(e) => toggleDropdown(index, e)}
                        onBlur={closeDropdown}
                      />
                    </Tooltip>
                    {dropdownOpen === index && (
                      <div
                        className="dropdown-list-container"
                        style={{ width: "200px", marginLeft: "-10px" }}
                      >
                        <div className="dropdown-list">
                          {filteredConfigGroups.map((group, gIndex) => (
                            <div
                              key={gIndex}
                              className="dropdown-item"
                              onMouseDown={() =>
                                handleConfigSelect(index, group)
                              }
                            >
                              {group}
                            </div>
                          ))}
                          {configSearchText &&
                            !filteredConfigGroups.includes(
                              configSearchText
                            ) && (
                              <div
                                className="dropdown-item create-new"
                                onMouseDown={() =>
                                  handleConfigSelect(index, configSearchText)
                                }
                              >
                                Create "{configSearchText}"
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  </div>
                </td>
                <td>
                  <div className="select-wrapper">
                    <Tooltip title={item.type}>
                      <select
                        value={item.type}
                        onChange={(e) =>
                          handleTypeChange(index, e.target.value)
                        }
                        className="table-select"
                      >
                        <option className="type-option" value="Discrete">
                          Discrete
                        </option>
                        <option className="type-option" value="Dropdown">
                          Dropdown
                        </option>
                      </select>
                    </Tooltip>
                  </div>
                </td>
                <td
                  onClick={() => handleValueDialogOpen(index)}
                  className="values-cell"
                >
                  <div className="chip-container">
                    {item.values.length > 0 ? (
                      item.values.map((val, vIndex) => (
                        <Tooltip title={val.value}>
                          <span key={vIndex} className="chip">
                            {val.value}
                            <span
                              className="chip-delete"
                              onClick={(e) =>
                                handleDeleteChip(index, vIndex, e)
                              }
                            >
                              ✕
                            </span>
                          </span>
                        </Tooltip>
                      ))
                    ) : (
                      <span className="empty-values">Click to add values</span>
                    )}
                  </div>
                </td>
                <td>
                  <div>
                    <button
                      onClick={() => {
                        handleDelete(item);
                      }}
                      className="delete-button"
                    >
                      &times;
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {openValueDialog && (
        <div className="modal">
          <div className="modal-overlay" onClick={handleValueDialogClose}></div>
          <div className="modal-content">
            <div className="modal-header">
              <h3>Edit Values</h3>
              <button className="close-btn" onClick={handleValueDialogClose}>
                ✕
              </button>
            </div>
            <div className="modal-body">
              <table className="values-table">
                <thead>
                  <tr>
                    <th>Value</th>
                    <th>Description</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {valueDialogData.map((val, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          value={val.value}
                          onChange={(e) =>
                            handleValueChange(index, "value", e.target.value)
                          }
                          className="dialog-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={val.description}
                          onChange={(e) =>
                            handleValueChange(
                              index,
                              "description",
                              e.target.value
                            )
                          }
                          className="dialog-input"
                        />
                      </td>
                      <td>
                        <button
                          className="icon-btn delete-btn"
                          onClick={() => handleRemoveValue(index)}
                        >
                          ✕
                        </button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td>
                      <input
                        type="text"
                        placeholder="New value"
                        value={newValue.value}
                        onChange={(e) =>
                          setNewValue({ ...newValue, value: e.target.value })
                        }
                        className="dialog-input"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        placeholder="Description"
                        value={newValue.description}
                        onChange={(e) =>
                          setNewValue({
                            ...newValue,
                            description: e.target.value,
                          })
                        }
                        className="dialog-input"
                      />
                    </td>
                    <td>
                      <button
                        className="icon-btn add-btn"
                        onClick={handleAddValue}
                      >
                        +
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={handleValueDialogClose}>
                Cancel
              </button>
              <button className="btn primary-btn" onClick={handleSaveValues}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigEditor;
